module.exports = __webpack_public_path__ + "static/img/faster-login.7407938.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img-text/images/faster-login.svg
// module id = rqTX
// module chunks = 26